import { render, staticRenderFns } from "./CodeBraces.vue?vue&type=template&id=42d62230&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CodeBraces.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/CodeBraces.vue
// module id = 2389
// module chunks = 1